import { Pathfinder } from './../pathfinding/Pathfinder';
import { AStar, heuristics } from './../pathfinding/AStar';

export class AIController {
    constructor(game) {
        this.tilemap = game.tilemap;
        this.player = game.player;

        this.pathfinder = new Pathfinder(this.tilemap.collisionGraph, AStar, { heuristic: heuristics.diagonal });
        this.entities = new Map();
    }

    addEntity(entity) {
        this.entities.set(entity.id, entity);
    }

    removeEntity(entity) {
        this.entities.delete(entity.id, entity);
    }

    update(dt) {
        this.entities.forEach((entity, entityId) => {
            // Check if the entity is following someone.
            if (entity.target) {
                if (!entity.isMoving) {
                    // Check if the target has moved and we need to regen its path.
                    if (entity.target.lastTileX !== entity.target.entity.tilePos.x ||
                        entity.target.lastTileY !== entity.target.entity.tilePos.y) {
                        entity.target.lastTileX = entity.target.entity.tilePos.x;
                        entity.target.lastTileY = entity.target.entity.tilePos.y;
                        entity.target.path = this.pathfinder.pathTo(entity.tilePos, entity.target.entity.tilePos);
                        entity.goneBack = false;
                    }

                    // Check if we're at the destination.
                    let diffX = entity.tilePos.x - entity.target.entity.tilePos.x;
                    let diffY = entity.tilePos.y - entity.target.entity.tilePos.y;
                    if (Math.abs(diffX) <= 1 && Math.abs(diffY) <= 1) entity.target.path = [];
                }

                // If we have a path to follow and we're not moving then follow it.
                if (!entity.isMoving && entity.target.path && !entity.goneBack) {
                    let node = null;
                    if (entity.target.path.length > 2){
                        node = entity.target.path.shift();
                        entity.history.push({x: node.x * -1, y: node.y * -1});
                    }
                    else if (entity.history.length > 0){
                        node = entity.history.pop();
                        entity.target.path.push({x: node.x * -1, y: node.y * -1});
                        entity.goneBack = true;
                    }
                    if (node){
                        entity.moveTo(node);
                    }
                }
            }
        });
    }
}
